(() => {
  const root = document.querySelector('[data-finder-steps]');
  const resultsWrap = document.querySelector('[data-finder-results]');
  const sectionId = document.querySelector('.product-finder').dataset.sectionId;

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function getAllSteps() {
    return Array.from(root.querySelectorAll('.finder-step'));
  }

  function isAnswered(fieldset) {
    const select = fieldset.querySelector('select[data-filter-param]');
    if (select) return !!select.value;
    return !!fieldset.querySelector('[data-filter-param].is-active');
  }

  function getActiveLabel(fieldset) {
    const select = fieldset.querySelector('select[data-filter-param]');
    if (select) {
      const opt = select.selectedOptions[0];
      return opt && opt.value ? opt.textContent.trim() : '';
    }
    const active = fieldset.querySelector('[data-filter-param].is-active');
    if (!active) return '';
    const strong = active.querySelector('strong');
    if (strong) return strong.textContent.trim();
    const swatchLabel = active.querySelector('.finder-swatch__label');
    if (swatchLabel) return swatchLabel.textContent.trim();
    if (active.dataset.selectedLabel) return active.dataset.selectedLabel;
    return active.textContent.trim();
  }

  function updateStepSummary(fieldset) {
    const summaryEl = fieldset.querySelector('[data-finder-step-summary]');
    if (summaryEl) summaryEl.textContent = getActiveLabel(fieldset);
  }

  function updateAnsweredCount() {
    const steps = getAllSteps();
    const answered = steps.filter(isAnswered).length;
    const el = document.querySelector('[data-finder-answered-count]');
    if (el) el.textContent = answered;
  }

  function openStep(fieldset) {
    getAllSteps().forEach((f) => f.classList.remove('is-open'));
    if (fieldset) fieldset.classList.add('is-open');
  }

  function advanceToNextStep(currentFieldset) {
    const steps = getAllSteps();
    const idx = steps.indexOf(currentFieldset);
    for (let i = idx + 1; i < steps.length; i++) {
      if (!isAnswered(steps[i])) {
        openStep(steps[i]);
        return;
      }
    }
    currentFieldset.classList.remove('is-open');
  }

  function syncResultsCount(doc) {
      const fetchedCount = doc.querySelector('[data-finder-results-count]');
      const liveCount = document.querySelector('[data-finder-results-count]');
      if (fetchedCount && liveCount) liveCount.textContent = fetchedCount.textContent;
    }

    function syncStepAvailability(doc) {
    const fetchedRoot = doc.querySelector('[data-finder-steps]');
    if (!fetchedRoot) return;

    root.querySelectorAll('[data-filter-param][data-filter-value]').forEach((liveEl) => {
      const param = liveEl.dataset.filterParam;
      const value = liveEl.dataset.filterValue;
      const fetchedEl = Array.from(fetchedRoot.querySelectorAll('[data-filter-param][data-filter-value]'))
        .find((el) => el.dataset.filterParam === param && el.dataset.filterValue === value);
      if (fetchedEl) {
        liveEl.disabled = fetchedEl.disabled;
      }
    });

    root.querySelectorAll('select[data-filter-param]').forEach((liveSelect) => {
      const param = liveSelect.dataset.filterParam;
      const fetchedSelect = fetchedRoot.querySelector(`select[data-filter-param="${param}"]`);
      if (!fetchedSelect) return;
      Array.from(liveSelect.options).forEach((liveOpt) => {
        if (!liveOpt.value) return;
        const fetchedOpt = Array.from(fetchedSelect.options).find((o) => o.value === liveOpt.value);
        if (fetchedOpt) liveOpt.disabled = fetchedOpt.disabled;
      });
    });
  }

  async function fetchResults(params, { append = false } = {}) {
    params.set('section_id', sectionId);
    const res = await fetch(`${window.location.pathname}?${params.toString()}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = doc.querySelector('[data-finder-grid]');
    const loadMore = doc.querySelector('[data-finder-load-more]');

    if (!grid) return;

    if (append) {
      resultsWrap.querySelector('[data-finder-grid]').append(...grid.children);
    } else {
      resultsWrap.querySelector('[data-finder-grid]').innerHTML = grid.innerHTML;
    }

    const existingBtn = resultsWrap.querySelector('[data-finder-load-more]');
    if (existingBtn) existingBtn.remove();
    if (loadMore) resultsWrap.appendChild(loadMore);

    syncResultsCount(doc);
    syncStepAvailability(doc);
  }

  root.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-finder-step-toggle]');
    if (toggle) {
      const fieldset = toggle.closest('.finder-step');
      if (fieldset.classList.contains('is-open')) {
        fieldset.classList.remove('is-open');
      } else {
        openStep(fieldset);
      }
      return;
    }

    const control = e.target.closest('[data-filter-param]');
    if (!control || control.tagName === 'SELECT') return;

    const params = currentParams();
    const { filterParam, filterValue } = control.dataset;
    params.delete('page');

    const isCurrentlyActive = control.classList.contains('is-active');

    if (isCurrentlyActive) {
      params.delete(filterParam);
    } else {
      params.delete(filterParam);
      params.set(filterParam, filterValue);
    }

    const stepFieldset = control.closest('fieldset');
    stepFieldset.querySelectorAll('[data-filter-param].is-active').forEach((el) => {
      el.classList.remove('is-active');
    });
    if (!isCurrentlyActive) {
      control.classList.add('is-active');
    }

    const select = stepFieldset.querySelector('select[data-filter-param]');

    if (select) {
      select.value = isCurrentlyActive ? '' : filterValue;
    }

    if (control.closest('[data-step="7"]')) {
      const labelEl = document.querySelector('[data-finder-color-label]');
      if (labelEl) {
        labelEl.textContent = isCurrentlyActive ? '' : control.dataset.selectedLabel;
      }
    }

    updateStepSummary(stepFieldset);
    updateAnsweredCount();
    if (!isCurrentlyActive) advanceToNextStep(stepFieldset);

    history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
    fetchResults(params);
  });

  root.addEventListener('change', (e) => {
    const select = e.target.closest('select[data-filter-param]');
    if (!select) return;

    const params = currentParams();
    params.delete('page');
    const stepFieldset = select.closest('fieldset');

    if (select.value) {
      params.set(select.dataset.filterParam, select.value);
    } else {
      params.delete(select.dataset.filterParam);
    }

    updateStepSummary(stepFieldset);
    updateAnsweredCount();
    if (select.value) advanceToNextStep(stepFieldset);

    history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
    fetchResults(params);
  });

  resultsWrap.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-finder-load-more]');
    if (!btn) return;
    const nextUrl = new URL(btn.dataset.nextUrl, window.location.origin);
    const params = new URLSearchParams(nextUrl.search);
    history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
    fetchResults(params, { append: true });
  });

  function clearAllFilters() {
    const steps = getAllSteps();
    steps.forEach((f) => {
      f.querySelectorAll('[data-filter-param].is-active').forEach((el) => el.classList.remove('is-active'));
      const select = f.querySelector('select[data-filter-param]');
      if (select) select.value = '';
      updateStepSummary(f);
    });
    const colorLabelEl = document.querySelector('[data-finder-color-label]');
    if (colorLabelEl) colorLabelEl.textContent = '';

    updateAnsweredCount();

    const firstStep = steps[0];

    openStep(firstStep);

    //scroll to first step with offset
    if (firstStep) {
      const offset = 250;
      const top = firstStep.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }

    history.pushState({}, '', window.location.pathname);
    fetchResults(new URLSearchParams());
  }

  document.querySelectorAll('[data-finder-clear-all]').forEach((btn) => {
    btn.addEventListener('click', clearAllFilters);
  });

  window.addEventListener('popstate', () => fetchResults(currentParams()));

  // initial state
  const steps = getAllSteps();
  steps.forEach(updateStepSummary);
  updateAnsweredCount();
  const firstUnanswered = steps.find((f) => !isAnswered(f));
  openStep(firstUnanswered || null);
})();